<template>
  <div class="page-container">
    <div class="form-signin px-10">
      <div class="page-title border-0">{{$t('pages.login.login')}}</div>
      <ValidationObserver ref="formLogin" tag="div" v-slot="{ handleSubmit }">
        <ValidationProvider rules="required" class="form-group mb-20" tag="div"
          :name="$t('pages.login.email')" v-slot="{ errors }" mode="passive">
          <input class="form-control" v-model="credentials.mail" type="email" :placeholder="$t('pages.login.enter_your_mail')"/>
          <div class="error-msg" v-if="errors[0]">{{ errors[0] }}</div>
        </ValidationProvider>
        <ValidationProvider rules="required|min:6|max:20" class="form-group mb-20" tag="div"
          :name="$t('pages.login.password')" v-slot="{ errors }" mode="passive">
          <input class="form-control mb-15" v-model="credentials.password" type="password"
            :placeholder="$t('pages.login.enter_your_pass')" />
            <div class="error-msg" v-if="errors[0]">{{ errors[0] }}</div>
        </ValidationProvider>
        <div class="reset-pass text-center">
          <router-link :to="{name: 'ForgotPassword'}">{{$t('pages.login.forgot_password')}}</router-link>
        </div>
        <div class="button-group text-center mt-30">
          <button class="btn btn-dark btn-thin mb-10" type="submit" @click.prevent="handleSubmit(onClickLogin)">
            {{$t('pages.login.login')}}</button>
          <button class="btn btn-border btn-thin mb-10" @click.prevent="$router.push({name: 'ServiceDescriptionCloud'})">{{$t('pages.login.register_now')}}</button>
        </div>
      </ValidationObserver>
    </div>
    <ModalConflictLogin ref="modalConflictLogin" @forceLogin="onClickLogin(true)" />
  </div>
</template>

<script>
import {API_LOGIN} from '@/configs/api.js'
import ModalConflictLogin from './ModalConflictLogin.vue'
export default {
  name: 'Login',
  data () {
    return {
      credentials: {
        mail: '',
        password: '',
      },
      errors: {},
      isErrorLogin: false,
      isCallingApi: false,
    };
  },
  components: {
    ModalConflictLogin,
  },
  methods: {
    async onClickLogin (forceLogin = false) {
      let result = await this.$refs.formLogin.validate()
      if (result) {
        this.isErrorLogin = false;
        if (this.isCallingApi) {
          return;
        }
        this.isCallingApi = true;
        try {
          if (forceLogin) {
            this.credentials.force_login = true
          }
          let resLogin = await this.$api.post(API_LOGIN, this.credentials);
          this.isCallingApi = false;
          if (resLogin.data.code === 200) {
            const userInfo = resLogin.data.user_info;
            this.$store.commit('SET_USER_INFO', userInfo);
            if (userInfo.account_level === this.$constant.ADMIN_LEVEL) {
              this.$router.push({name: 'ManagerConstruction'});
            } else if (userInfo.account_level === this.$constant.SUPERVISOR_LEVEL) {
              this.$router.push({name: 'ListConstruction', params: {manager_user_id: userInfo.user_id}});
            } else {
              this.$router.push({name: 'ProjectList'});
            }
          } else {
            if (resLogin.data.code === 406) {
              this.$refs.modalConflictLogin.openModal();
            }
            this.isCallingApi = false;
            this.isErrorLogin = true;
          }
        } catch (error) {
          this.isCallingApi = false;
          console.error(error);
        }
      } else {
        this.isErrorLogin = true;
      }
    }
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Login.vue